const backendURL = "https://mockexchange.prod-ai.com/"
//const backendURL = "";
let originalImage;
window.ShopifyCustomer = {
    id: "GlobalUser",
    email: "global@gmail.com",
};

// Global variables to track smart object properties
let currentSmartObjectSizes = [];
let currentSmartObjectIndex = 0;
let imagePosition = { top: 0, left: 0 };
let imageScale = 1;
let isSaved = false

document.addEventListener("DOMContentLoaded", function () {
    const font = new FontFace('Neue Montreal', 'url(/fonts/NeueMontreal-Regular.otf)');
    font.load().then(function(loadedFont) {
        document.fonts.add(loadedFont);
        document.body.style.fontFamily = "'Neue Montreal', Arial, sans-serif";
    });
});
// PSD File upload
document.addEventListener("DOMContentLoaded", function () {
    const psdFileInput = document.getElementById("psd-file-input");
    const psdUploadLabel = document.getElementById("psd-upload-label");
    const progressBar = document.getElementById("psd-upload-progress-bar");
    const progressFill = document.getElementById("psd-upload-progress-fill");

    psdFileInput.addEventListener("change", function () {
        if (psdFileInput.files && psdFileInput.files[0]) {
            // Optionally, show the progress bar when a file is selected
            progressBar.style.display = "block";
            progressFill.style.width = "0%";
        } else {
            progressBar.style.display = "none";
            progressFill.style.width = "0%";
        }
    });

    psdUploadLabel.addEventListener("click", function () {
        psdFileInput.click();
    });

    psdFileInput.addEventListener("change", function (e) {
        if (this.files && this.files[0]) {
            const file = this.files[0];
            if (!file.name.toLowerCase().endsWith(".psd")) {
                alert("Please select a .psd file.");
                progressBar.style.display = "none";
                return;
            }

            psdUploadLabel.style.display = "none";
            progressBar.style.display = "block";
            progressFill.style.width = "0%";

            const formData = new FormData();
            formData.append("file", file);

            // Use XMLHttpRequest for upload progress
            const xhr = new XMLHttpRequest();
            xhr.open("POST", `${backendURL}/upload-psd-dynamic-mockups`, true);

            xhr.upload.onprogress = function (event) {
                const uploadBoxText = document.querySelector('.upload-box.small .upload-box-text');
                if (uploadBoxText) {
                    uploadBoxText.textContent = "Uploading...";
                    uploadBoxText.title = "";
                }
                if (event.lengthComputable) {
                    const percent = (event.loaded / event.total) * 80;
                    progressFill.style.width = percent + "%";
                }
            };

            xhr.onload = function () {
                progressFill.style.width = "100%";

                const slider = document.getElementById("preview-slider");
                const sliderValue = document.getElementById("slider-value");
                if (slider && sliderValue) {
                    slider.value = 50;
                    sliderValue.textContent = "50%";
                    slider.dispatchEvent(new Event("input"));
                }

                setTimeout(() => {
                    progressBar.style.display = "none";
                    progressFill.style.width = "0%";
                    psdUploadLabel.style.display = "inline-block";
                }, 600);

                try {
                    const data = JSON.parse(xhr.responseText);
                    if (
                        data.status === "success" &&
                        data.api_response &&
                        data.api_response.data
                    ) {

                        // Sanitize filename to prevent XSS
                        let filename = data.filename || file.name;
                        filename = filename.replace(/[^a-zA-Z0-9_\-\.]/g, '');

                        // Truncate if longer than 20 chars (before .psd)
                        if (filename.length > 20 && filename.toLowerCase().endsWith('.psd')) {
                            const ext = 'psd';
                            const base = filename.slice(0, 12);
                            filename = base + "..." + ext;
                        }

                        // Replace the text in the upload-box-text div
                        const uploadBoxText = document.querySelector('.upload-box.small .upload-box-text');
                        if (uploadBoxText) {
                            uploadBoxText.textContent = filename;
                            uploadBoxText.title = (data.filename || file.name).replace(/[^a-zA-Z0-9_\-\.]/g, '');
                        }

                        const template = {
                            name: data.api_response.data.name || "Uploaded Mockup",
                            thumbnail_url: data.api_response.data.thumbnails?.[0]?.url || "",
                            mockup_uuid: data.api_response.data.uuid,
                            smart_object_uuids: (data.api_response.data.smart_objects || []).map((obj) => obj.uuid),
                            smart_object_sizes: (data.api_response.data.smart_objects || []).map((obj) => obj.size),
                            product_id: "",
                        };
                        selectMockupTemplate(template);
                        ensureDownloadUI();
                    } else {
                        alert("Failed to upload mockup. Please try again.");
                    }
                } catch (err) {
                    alert("Error uploading mockup: " + err.message);
                }
            };

            xhr.onerror = function () {
                progressBar.style.display = "none";
                progressFill.style.width = "0%";
                alert("Error uploading mockup.");
            };

            xhr.send(formData);
        }
    });
});

// Preview Zoom Slider
document.addEventListener("DOMContentLoaded", function () {
    const slider = document.getElementById("preview-slider");
    const sliderValue = document.getElementById("slider-value");

    
    function updateZoomedImage() {
        sliderValue.textContent = slider.value + "%";
        // Prefer rendered image, fallback to preview image
        let img = document.querySelector(".rendered-mockup") ||
                document.getElementById("mockup-result-preview-image");
        let previewClip = document.getElementById("preview-image-clip");
        if (img && previewClip && (img.naturalWidth || img.width)) {
            const scale = slider.value / 100;
            const baseWidth = img.naturalWidth || img.width;
            const baseHeight = img.naturalHeight || img.height;
            const aspectRatio = baseWidth / baseHeight;
            const maxWidth = previewClip.clientWidth;
            const maxHeight = previewClip.clientHeight;

            let width, height;
            if (maxWidth / aspectRatio <= maxHeight) {
                // Width is the limiting factor
                width = maxWidth * scale;
                height = width / aspectRatio;
            } else {
                // Height is the limiting factor
                height = maxHeight * scale;
                width = height * aspectRatio;
            }

            img.style.display = "block";
            img.style.width = width + "px";
            img.style.height = height + "px";
        }
    }

    slider.addEventListener("input", updateZoomedImage);
    // Call once on load
    updateZoomedImage();
});

function ensureDownloadUI() {
    const previewSection = document.getElementById("editing-tool-preview-section");

    // Progress Bar
    let progressBar = document.getElementById("download-progress-bar");
    if (!progressBar) {
        progressBar = document.createElement("div");
        progressBar.id = "download-progress-bar";
        progressBar.className = "download-progress-bar";
        progressBar.style.display = "none";
        progressBar.innerHTML = `
            <div class="download-progress-label">
                Downloading image <span class="sparkle">✨</span>
            </div>
            <div class="download-progress-track">
                <div id="download-progress-fill" class="download-progress-fill"></div>
            </div>
        `;
        previewSection.appendChild(progressBar);
    }
    // Now progressFill is always defined
    let progressFill = progressBar.querySelector("#download-progress-fill");

    // Download Button
    let downloadBtn = document.getElementById("editing-tool-download-button");
    if (!downloadBtn) {
        downloadBtn = document.createElement("button");
        downloadBtn.id = "editing-tool-download-button";
        downloadBtn.className = "download-btn";
        downloadBtn.textContent = "Download";
        previewSection.appendChild(downloadBtn);

        // Attach the click handler (move your logic here if needed)
        downloadBtn.onclick = function () {
            // UI: disable button, show progress bar
            downloadBtn.disabled = true;
            downloadBtn.textContent = "Preparing...";
            progressBar.style.display = "flex";
            progressFill.style.width = "0%";

            // Prepare smart objects array for the API (reuse from applyImageToMockup)
            saveCurrentSmartObjectState();
            const smartObjects = window.selectedTemplate.smart_object_uuids.map(
                (uuid, index) => {
                    const state = window.smartObjectsState[index];
                    if (!state || !state.hasImage || !state.imageUrl) {
                        return { uuid: uuid, asset: { url: null } };
                    }
                    const smartObjectSize = currentSmartObjectSizes[index];
                    const originalWidth = parseInt(smartObjectSize.width, 10);
                    const originalHeight = parseInt(smartObjectSize.height, 10);
                    const imageDimensions = state.imageDimensions || { naturalWidth: 0, naturalHeight: 0 };
                    const frameDimensions = state.frameDimensions || { clientWidth: 300, clientHeight: 300 };                                const positionScaleX = originalWidth / frameDimensions.clientWidth;
                    const positionScaleY = originalHeight / frameDimensions.clientHeight;
                    const positionPixels = {
                        left: state.positionRatio.left * originalWidth,
                        top: state.positionRatio.top * originalHeight,
                    };
                    if (!window[`scaleX_${index}`]) window[`scaleX_${index}`] = state.scaleX;
                    if (!window[`scaleY_${index}`]) window[`scaleY_${index}`] = state.scaleY;
                    const sizePixels = {
                        width: state.scaleXRatio * originalWidth,
                        height: state.scaleYRatio * originalHeight,
                    };
                    const opacityVal = parseInt(document.getElementById("editing-tool-adjust-opacity-slider").value);
                    const customColorPicker = document.getElementById('custom-color-picker');
                    let colorValue = null;
                    if (customColorPicker) colorValue = customColorPicker.value;
                    const payload = {
                        uuid: uuid,
                        asset: {
                            url: state.imageUrl,
                            size: sizePixels,
                            position: positionPixels,
                        },
                        adjustment_layers: { opacity: opacityVal },
                    };
                    if (colorValue) payload.color = colorValue;
                    return payload;
                }
            );
            const requestData = {
                mockup_uuid: window.selectedTemplate.mockupUuid,
                smart_objects: smartObjects,
            };

            // Simulate progress (for demo, real progress depends on backend)
            let fakeProgress = 0;
            const progressInterval = setInterval(() => {
                fakeProgress += Math.random() * 10 + 5;
                if (fakeProgress > 90) fakeProgress = 90;
                progressFill.style.width = fakeProgress + "%";
            }, 200);

            // Make the API request
            fetch(`${backendURL}/render-mockup-full`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            })
            .then(response => {
                if (response.status === 429) {
                showTooManyRequestsPopup();
                throw new Error("Too many requests");
                }
                return response.json();
            })
            .then((data) => {
                clearInterval(progressInterval);
                progressFill.style.width = "100%";
                setTimeout(() => {
                    progressBar.style.display = "none";
                }, 800);

                downloadBtn.disabled = false;
                downloadBtn.textContent = "Download";

                if (data.status === "success") {
                    const renderedUrl = data.data.data.export_path;
                    if (renderedUrl) {
                        // Start download automatically
                        const a = document.createElement("a");
                        a.href = renderedUrl;
                        a.download = "mockup.png";
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    } else {
                        alert("Missing URL in API response. Please try again.");
                    }
                } else {
                    alert(data.message || "Failed to render mockup. Please try again.");
                }
            })
            .catch((error) => {
                clearInterval(progressInterval);
                progressBar.style.display = "none";
                downloadBtn.disabled = false;
                downloadBtn.textContent = "Download";
                alert("Network error: " + error.message);
            });
        };
    }
}

function showTooManyRequestsPopup() {
    // Remove any existing popup
    const existing = document.querySelector('.too-many-requests-popup');
    if (existing) existing.remove();

    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'too-many-requests-popup';

    // Create popup content
    overlay.innerHTML = `
        <div class="popup-content">
            <button class="close-btn" title="Close">&times;</button>
            <div style="margin-bottom: 18px;">
                <span style="font-size:2.2rem;display:inline-block;margin-bottom:10px;">🚦</span><br>
                <b>There is a lot of traffic,<br>please wait a bit and try again.</b>
            </div>
        </div>
    `;

    // Add close handler
    overlay.querySelector('.close-btn').onclick = () => overlay.remove();

    // Add to body
    document.body.appendChild(overlay);
}

// The GOAT function
function selectMockupTemplate(template) {
    currentSmartObjectIndex = 0;
    currentSmartObjectSizes = template.smart_object_sizes;
    window.smartObjectsState = new Array(currentSmartObjectSizes.length)
        .fill(null)
        .map(() => ({
            imageUrl: null,
            position: { top: 0, left: 0 },
            scaleX: 1,
            scaleY: 1,
            hasImage: false,
            imageDimensions: null,
            frameDimensions: null,
            positionRatio: { left: 0, top: 0 },
            scaleXRatio: 1,
            scaleYRatio: 1,
        }));

        const frame = document.getElementById("smart-object-frame");
        if (frame) {
            frame.style.width = "15vw";
            frame.style.height = "15vw";
        }

    // Remove any rendered image from previous PSD
    const previewClip = document.getElementById("preview-image-clip");
    if (previewClip) {
        // Remove all rendered images
        const renderedImgs = previewClip.querySelectorAll(".rendered-mockup");
        renderedImgs.forEach(img => img.remove());
    }
    // Optionally, reset the preview slider to default
    const slider = document.getElementById("preview-slider");
    const sliderValue = document.getElementById("slider-value");
    if (slider && sliderValue) {
        slider.value = 50;
        sliderValue.textContent = "50%";
        slider.dispatchEvent(new Event("input"));
    }
    const previewSection = document.getElementById("editing-tool-preview-section");

    const currentImage = document.querySelector(
        "#draggable-image-container img"
    );
    const hasCurrentImage = !!currentImage;
    const currentImageUrl = hasCurrentImage
        ? currentImage.src
        : null;

    console.log("Selected template:", template.name);
    console.log("Mockup UUID:", template.mockup_uuid);
    console.log("Smart Object UUIDs:", template.smart_object_uuids);

    // Store the selected template info for later use when applying image
    window.selectedTemplate = {
        mockupUuid: template.mockup_uuid,
        smart_object_uuids: template.smart_object_uuids,
        name: template.name,
        smart_object_sizes: template.smart_object_sizes,
    };

    // Store smart object sizes from the selected template
    currentSmartObjectSizes =
        window.selectedTemplate.smart_object_sizes;

    // Reset smart objects state for the new template
    window.smartObjectsState = new Array(
        currentSmartObjectSizes.length
    )
        .fill(null)
        .map(() => ({
            imageUrl: null,
            position: { top: 0, left: 0 },
            scaleX: 1,
            scaleY: 1,
            hasImage: false,
        }));

    // Load the template thumbnail
    console.log("Loading template image:", template.thumbnail_url);
    loadTemplateImage(template.thumbnail_url);

    // Clear the image and bring back the upload UI in the large upload box
    showLargeUploadUI(true);
    const removeBtn = document.querySelector('.image-remove-button');
    if (removeBtn) removeBtn.style.display = "none";
}

function showLargeUploadUI(show) {
    const largeBox = document.getElementById("large-upload-box");
    const uploadIcon = largeBox.querySelector(".upload-svg-icon");
    const uploadText = largeBox.querySelector(".upload-box-text");
    const uploadBtn = document.getElementById("auto-upload-button");
    const uploadSection = largeBox.querySelector(".editing-tool-upload-section");

    if (show) {
        largeBox.classList.remove("pattern-bg");
        if (uploadIcon) uploadIcon.style.display = "";
            if (uploadText) {
            uploadText.style.display = "";
            uploadText.textContent = "Add your image"; // <-- revert text
            uploadText.title = ""; // <-- clear tooltip
        }
        if (uploadBtn) uploadBtn.style.display = "";
        if (uploadSection) uploadSection.style.display = "none";
    } else {
        largeBox.classList.add("pattern-bg");
        if (uploadIcon) uploadIcon.style.display = "none";
        if (uploadText) uploadText.style.display = "none";
        if (uploadBtn) uploadBtn.style.display = "none";
        if (uploadSection) uploadSection.style.display = "";
    }
}

// Function to handle image upload and make it draggable
function handleImageUpload(imageUrl) {
    // Get the container
    const imageContainer = document.getElementById(
        "draggable-image-container"
    );
    imageContainer.innerHTML = ""; // Clear previous image

    // Create new image
    const img = document.createElement("img");
    img.crossOrigin = "anonymous";
    img.src = imageUrl;

    img.style.zIndex = "-1";

    img.onload = function () {
        // Add the image to the container
        imageContainer.appendChild(img);

        showLargeUploadUI(false);
        // // Update the smart object frame to reflect the first smart object's dimensions
        updateSmartObjectFrame(currentSmartObjectIndex); // Default to first smart object
        
        imageContainer.style.zIndex = "2";
        
        const largeBox = document.getElementById("large-upload-box");
        let existingDeleteBtn = largeBox.querySelector(".image-remove-button");
        if (existingDeleteBtn) existingDeleteBtn.remove();

        // Create the new SVG delete button
        const removeButton = document.createElement("button");
        removeButton.className = "image-remove-button";
        removeButton.title = "Remove image";
        removeButton.style.position = "absolute";
        removeButton.style.top = "18px";
        removeButton.style.right = "18px";
        removeButton.style.width = "40px";
        removeButton.style.height = "40px";
        removeButton.style.background = "transparent";
        removeButton.style.border = "none";
        removeButton.style.padding = "0";
        removeButton.style.zIndex = "20";
        removeButton.style.cursor = "pointer";
        removeButton.style.display = "flex";
        removeButton.style.alignItems = "center";
        removeButton.style.justifyContent = "center";

        // SVG icon as innerHTML
        removeButton.innerHTML = `
        <svg width="36" height="36" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="70" cy="70" r="68.5" fill="white" stroke="black" stroke-width="3"/>
        <line x1="100.061" y1="41.0616" x2="40.0607" y2="101.062" stroke="black" stroke-width="3"/>
        <line x1="99.6293" y1="101.357" x2="39.9323" y2="41.0556" stroke="black" stroke-width="3"/>
        </svg>
        `;

        // Add to the upload-box.large (not the image container)
        largeBox.appendChild(removeButton);

        // Add click event to remove button
        removeButton.addEventListener("click", function (e) {
            e.stopPropagation(); // Prevent triggering drag events
            resetSmartObjectFrame();
            showLargeUploadUI(true);

            // Reset the upload-box-text to default
            const uploadBoxText = document.querySelector('#large-upload-box .upload-box-text');
            if (uploadBoxText) {
                uploadBoxText.textContent = "Add your image";
                uploadBoxText.title = "";
            }

            // Update state to reflect image removal
            if (
                window.smartObjectsState &&
                window.smartObjectsState[currentSmartObjectIndex]
            ) {
                window.smartObjectsState[
                    currentSmartObjectIndex
                ].hasImage = false;
                window.smartObjectsState[
                    currentSmartObjectIndex
                ].imageUrl = null;
            }

            removeButton.style.display = "none";
        });

        const smartObjectSize = currentSmartObjectSizes[currentSmartObjectIndex];
        const smartObjectWidth = parseInt(smartObjectSize.width, 10);
        const smartObjectHeight = parseInt(smartObjectSize.height, 10);

        // Get the smart object aspect ratio
        const smartObjectAspect = smartObjectWidth / smartObjectHeight;

        // Define what is "too long" or "too wide"
        const EXTREME_RATIO = 2.0; // You can adjust this threshold

        let multiplier = 0.9; // Default multiplier for normal aspect ratios

        if (smartObjectAspect > EXTREME_RATIO || smartObjectAspect < 1 / EXTREME_RATIO) {
            // Too wide or too tall
            multiplier = 0.5;
        }

        // Get the smart object frame dimensions
        const frame = document.getElementById("smart-object-frame");
        const frameWidth = frame.clientWidth;
        const frameHeight = frame.clientHeight;

        // Calculate initial scale to fit the image within the frame
        const imgAspectRatio = img.naturalWidth / img.naturalHeight;
        const frameAspectRatio = frameWidth / frameHeight;

        let initialScale;
        if (imgAspectRatio > frameAspectRatio) {
            // Image is wider than frame (proportionally)
            initialScale = (frameHeight / img.naturalHeight) * multiplier; // 90% of frame height
        } else {
            // Image is taller than frame (proportionally)
            initialScale = (frameWidth / img.naturalWidth) * multiplier; // 90% of frame width
        }

        // Apply initial scale and center the image
        imageScale = initialScale;
        window.imageScaleX = initialScale; // Initialize separate X scale
        window.imageScaleY = initialScale;
        imagePosition = {
            top:
                (frameHeight - img.naturalHeight * initialScale) /
                2,
            left:
                (frameWidth - img.naturalWidth * initialScale) / 2,
        };

        // Update the smart objects state
        if (window.smartObjectsState) {
            window.smartObjectsState[currentSmartObjectIndex] = {
                imageUrl: imageUrl,
                position: { ...imagePosition },
                scaleX: window.imageScaleX,
                scaleY: window.imageScaleY,
                hasImage: true,
            };
        }

        updateImageTransform(img);

        // Make the image draggable
        makeDraggable(img);

        // Make the image resizable
        makeResizable(img);

        // Re-render the mockup if needed
        if (window.selectedTemplate) {
            applyImageToMockup();
        }
    };

    // Save the uploaded image URL in the state for the current smart object
    if (!window.selectedUpload) window.selectedUpload = {};
    window.selectedUpload[currentSmartObjectIndex] = {
        imageUrl: imageUrl,
    };
}

// Function to update image transform based on position and scale
function updateImageTransform(imgElement) {
    imgElement.style.transform = `translate(${imagePosition.left}px, ${imagePosition.top}px) scale(${imageScale})`;
}

function checkCenterAlignment(element) {
    if (!element) return;

    const frame = document.getElementById("smart-object-frame");
    if (!frame) return;

    // Get guide elements
    const horizontalGuide = frame.querySelector(
        ".guide-line-horizontal"
    );
    const verticalGuide = frame.querySelector(
        ".guide-line-vertical"
    );

    if (!horizontalGuide || !verticalGuide) return;

    // Get separate scale values
    const scaleX = window.imageScaleX || imageScale;
    const scaleY = window.imageScaleY || imageScale;

    // Calculate dimensions using separate scales
    const imgWidth = element.naturalWidth * scaleX;
    const imgHeight = element.naturalHeight * scaleY;

    const frameCenterX = frame.clientWidth / 2;
    const frameCenterY = frame.clientHeight / 2;

    // Calculate image center using the imagePosition and scaled dimensions
    const imgCenterX = imagePosition.left + imgWidth / 2;
    const imgCenterY = imagePosition.top + imgHeight / 2;

    // Threshold for snapping (px)
    const threshold = 5;

    // Check horizontal center alignment
    if (Math.abs(imgCenterX - frameCenterX) < threshold) {
        // Show vertical guide
        verticalGuide.style.display = "block";

        // Snap to center horizontally
        imagePosition.left = frameCenterX - imgWidth / 2;
        element.style.transform = `translate(${imagePosition.left}px, ${imagePosition.top}px) scaleX(${scaleX}) scaleY(${scaleY})`;
    } else {
        verticalGuide.style.display = "none";
    }

    // Check vertical center alignment
    if (Math.abs(imgCenterY - frameCenterY) < threshold) {
        // Show horizontal guide
        horizontalGuide.style.display = "block";

        // Snap to center vertically
        imagePosition.top = frameCenterY - imgHeight / 2;
        element.style.transform = `translate(${imagePosition.left}px, ${imagePosition.top}px) scaleX(${scaleX}) scaleY(${scaleY})`;
    } else {
        horizontalGuide.style.display = "none";
    }

    // Update resize handles after snapping
    updateHandlePositions(element);
}

// Function to make an image draggable
function makeDraggable(element) {
    let startX, startY;
    let startPosX = imagePosition.left;
    let startPosY = imagePosition.top;
    let hasMoved = false;

    // Create guide lines (add once to the frame)
    const frame = document.getElementById("smart-object-frame");
    if (!frame.querySelector(".guide-line-horizontal")) {
        const horizontalGuide = document.createElement("div");
        horizontalGuide.className =
            "guide-line guide-line-horizontal";
        frame.appendChild(horizontalGuide);

        const verticalGuide = document.createElement("div");
        verticalGuide.className = "guide-line guide-line-vertical";
        frame.appendChild(verticalGuide);
    }

    // Get guide elements
    const horizontalGuide = frame.querySelector(
        ".guide-line-horizontal"
    );
    const verticalGuide = frame.querySelector(
        ".guide-line-vertical"
    );

    // Hide guides initially
    horizontalGuide.style.display = "none";
    verticalGuide.style.display = "none";

    // Mouse down event
    element.addEventListener("mousedown", startDrag);

    // Touch support
    element.addEventListener("touchstart", function (e) {
        e.preventDefault();
        const touch = e.touches[0];
        const mouseEvent = new MouseEvent("mousedown", {
            clientX: touch.clientX,
            clientY: touch.clientY,
        });
        startDrag(mouseEvent);
    });

    function startDrag(e) {
        e.preventDefault();

        // Record initial positions
        startX = e.clientX;
        startY = e.clientY;
        startPosX = imagePosition.left;
        startPosY = imagePosition.top;
        hasMoved = false;

        // Add event listeners for drag and end
        document.addEventListener("mousemove", dragMove);
        document.addEventListener("mouseup", dragEnd);
        document.addEventListener("touchmove", touchMove);
        document.addEventListener("touchend", dragEnd);
    }

    function dragMove(e) {
        e.preventDefault();
        hasMoved = true;

        // Calculate new position
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;

        imagePosition.left = startPosX + dx;
        imagePosition.top = startPosY + dy;

        // Get the separate scales
        const scaleX = window.imageScaleX || imageScale;
        const scaleY = window.imageScaleY || imageScale;

        // Update the image transform with the separate scales
        element.style.transform = `translate(${imagePosition.left}px, ${imagePosition.top}px) scaleX(${scaleX}) scaleY(${scaleY})`;

        // Update resize handles if they exist
        const resizeHandles =
            document.querySelectorAll(".resize-handle");
        if (resizeHandles.length > 0) {
            updateHandlePositions(element);
        }

        // Check for center alignment
        checkCenterAlignment(element);
    }

    function touchMove(e) {
        e.preventDefault();
        const touch = e.touches[0];
        const mouseEvent = new MouseEvent("mousemove", {
            clientX: touch.clientX,
            clientY: touch.clientY,
        });
        dragMove(mouseEvent);
    }

    function dragEnd() {
        // Remove event listeners
        document.removeEventListener("mousemove", dragMove);
        document.removeEventListener("mouseup", dragEnd);
        document.removeEventListener("touchmove", touchMove);
        document.removeEventListener("touchend", dragEnd);

        // Hide guide lines
        horizontalGuide.style.display = "none";
        verticalGuide.style.display = "none";

        // Get the separate scales and apply them correctly
        const scaleX = window.imageScaleX || imageScale;
        const scaleY = window.imageScaleY || imageScale;

        // Use scaleX and scaleY separately to maintain the stretched proportions
        element.style.transform = `translate(${imagePosition.left}px, ${imagePosition.top}px) scaleX(${scaleX}) scaleY(${scaleY})`;

        // Save the final position for API call
        console.log(
            "Image position saved:",
            imagePosition,
            "scaleX:",
            scaleX,
            "scaleY:",
            scaleY
        );

        window.scaleX = scaleX;
        window.scaleY = scaleY;

        // If the image was actually moved, and we have a template selected, rerender the mockup
        if (
            hasMoved &&
            window.selectedTemplate &&
            window.selectedUpload
        ) {
            if (window.renderTimer)
                clearTimeout(window.renderTimer);
            window.renderTimer = setTimeout(() => {
                applyImageToMockup();
            }, 300);
        }
    }
}

// Function to load the template image into a standard canvas
function loadTemplateImage(imageUrl) {
    const previewSection = document.getElementById("editing-tool-preview-section");
    const previewClip = document.getElementById("preview-image-clip");
    let img = document.getElementById("mockup-result-preview-image");
    let previewMessage = document.getElementById("preview-message");
    if (!previewMessage) {
        previewMessage = document.createElement("div");
        previewMessage.className = "preview-message";
        previewMessage.id = "preview-message";
        previewSection.appendChild(previewMessage);
    }
    if (!img) {
        img = document.createElement("img");
        img.id = "mockup-result-preview-image";
        img.className = "preview-img";
        img.alt = "Preview";
        img.style.display = "none";
        previewClip.appendChild(img);
    }
    // Show loading state
    previewMessage.style.display = "none";
    img.style.display = "none";
    previewSection.classList.remove("error");
        
    // Calculate the current scale
    const slider = document.getElementById("preview-slider");
    const scale = slider.value / 100;

    // Preload the image to get its dimensions
    const tempImg = new window.Image();
    tempImg.onload = function () {
        // Store original dimensions
        originalImage = {
            width: tempImg.naturalWidth,
            height: tempImg.naturalHeight,
            displayWidth: tempImg.naturalWidth,
            displayHeight: tempImg.naturalHeight,
        };

        // Set the src and show the image
        img.src = imageUrl;
        img.style.display = "block";

        img.style.width = (originalImage.displayWidth * scale) + "px";
        img.style.height = (originalImage.displayHeight * scale) + "px";
        img.className = "preview-img rendered-mockup"; // Add both classes for consistency
        img.style.display = "block";

    };
    tempImg.onerror = function () {
        previewMessage.style.display = "block";
        previewMessage.innerHTML = "<b>Failed to load image.<br>Try again.</b>";
        img.style.display = "none";
    };
    tempImg.src = imageUrl;

    ensureDownloadUI();
}

// Opacity slider handling + color adjustments
document.addEventListener("DOMContentLoaded", function () {
    let opacitySlider = document.getElementById(
        "editing-tool-adjust-opacity-slider"
    );

    const customColorPicker = document.getElementById('custom-color-picker');
    const colorSwatch = document.getElementById('color-picker-swatch');

    // Set initial swatch color
    colorSwatch.style.backgroundColor = customColorPicker.value;

    function valuesUpdated() {
        // Render the mockup with adjustments if we have a template and image selected
        if (window.selectedTemplate && window.selectedUpload) {
            if (window.adjustmentRenderTimer)
                clearTimeout(window.adjustmentRenderTimer);
            window.adjustmentRenderTimer = setTimeout(() => {
                applyImageToMockup();
            }, 300);
        }
    }

    opacitySlider.addEventListener("input", valuesUpdated);

    customColorPicker.addEventListener('input', function() {
        colorSwatch.style.backgroundColor = this.value;
        valuesUpdated();
    });

    // Clicking the swatch opens the color picker
    colorSwatch.addEventListener('click', function () {
        customColorPicker.click();
    });

});

// Image upload handling with API integration
document.addEventListener("DOMContentLoaded", function () {
    // Set up the auto upload button
    const autoUploadButton =
        document.getElementById("auto-upload-button");
    const fileInput = document.getElementById("image-file-input");

    const imageUploadLabel = document.querySelector('#large-upload-box .upload-box-text');
    const imageProgressBar = document.getElementById("image-upload-progress-bar");
    const imageProgressFill = document.getElementById("image-upload-progress-fill");

    // Click handler for the upload button
    autoUploadButton.addEventListener("click", function () {
        fileInput.click();
    });

    fileInput.addEventListener("change", function (e) {
    if (this.files && this.files[0]) {
        const file = this.files[0];

        // Show "Uploading..." and progress bar
        if (imageUploadLabel) {
            imageUploadLabel.textContent = "Uploading...";
            imageUploadLabel.title = "";
        }
        imageProgressBar.style.display = "block";
        imageProgressFill.style.width = "0%";

        const largeBox = document.getElementById("large-upload-box");
        const uploadIcon = largeBox.querySelector(".upload-svg-icon");
        const uploadBtn = document.getElementById("auto-upload-button");
        if (uploadBtn) uploadBtn.style.display = "none";

        // Use XMLHttpRequest for progress
        const reader = new FileReader();
        reader.onload = function (event) {
            const imageData = event.target.result;

            const xhr = new XMLHttpRequest();
            xhr.open("POST", `${backendURL}/upload-user-image`, true);
            xhr.setRequestHeader("Content-Type", "application/json");

            xhr.upload.onprogress = function (event) {
                if (event.lengthComputable) {
                    const percent = (event.loaded / event.total) * 80;
                    imageProgressFill.style.width = percent + "%";
                }
            };

            xhr.onload = function () {
                imageProgressFill.style.width = "100%";
                imageProgressBar.style.display = "none";
                imageProgressFill.style.width = "0%";

                try {
                    const data = JSON.parse(xhr.responseText);
                    if (data.status === "success") {
                        // Restore label to filename or default
                        if (imageUploadLabel) {
                            imageUploadLabel.textContent = file.name;
                            imageUploadLabel.title = file.name;
                        }
                        // Place the image in the smart object frame
                        handleImageUpload(data.url);
                    } else {
                        alert("Failed to upload image to server. Please try again.");
                        if (imageUploadLabel) imageUploadLabel.textContent = "Add your image";
                    }
                } catch (error) {
                    alert("Error uploading image: " + error.message);
                    if (imageUploadLabel) imageUploadLabel.textContent = "Add your image";
                }
            };

            xhr.onerror = function () {
                imageProgressBar.style.display = "none";
                imageProgressFill.style.width = "0%";
                alert("Error uploading image.");
                if (imageUploadLabel) imageUploadLabel.textContent = "Add your image";
            };

            xhr.send(JSON.stringify({
                uid: window.ShopifyCustomer.id,
                image_data: imageData,
            }));
        };
        reader.readAsDataURL(file);
    }
});
});

// Main magic function to apply the image to the mockup via API
function applyImageToMockup() {
    if (!window.selectedTemplate) {
        console.error("Cannot apply image: Template not selected");
        return;
    }

    // Check if any smart object has an image
    let hasAnyImage = false;
    if (window.smartObjectsState) {
        hasAnyImage = window.smartObjectsState.some(
            (state) => state && state.hasImage
        );
    }

    if (!hasAnyImage) {
        console.error("Cannot apply image: No images uploaded");
        return;
    }

    // Show loading state in the preview section
    const previewSection = document.querySelector(
        ".editing-tool-preview-section"
    );
    previewSection.innerHTML =
        '<div class="loading-spinner" style="font-size: 16px;">Rendering mockup...</div>';
    ensureDownloadUI();

    // Save the current smart object state before rendering
    saveCurrentSmartObjectState();

    // Prepare smart objects array for the API
    const smartObjects =
        window.selectedTemplate.smart_object_uuids.map(
            (uuid, index) => {
                const state = window.smartObjectsState[index];

                // Skip smart objects with no images
                if (!state || !state.hasImage || !state.imageUrl) {
                    return {
                        uuid: uuid,
                        // Return minimal required data for smart objects with no image
                        asset: {
                            url: null,
                        },
                    };
                }

                // Get the smart object size
                const smartObjectSize =
                    currentSmartObjectSizes[index];
                const originalWidth = parseInt(
                    smartObjectSize.width,
                    10
                );
                const originalHeight = parseInt(
                    smartObjectSize.height,
                    10
                );

                // Use stored dimensions from the state instead of current DOM elements
                const imageDimensions = state.imageDimensions || {
                    naturalWidth: 0,
                    naturalHeight: 0,
                };
                const frameDimensions = state.frameDimensions || {
                    clientWidth: 300,
                    clientHeight: 300,
                };

                // Calculate position scaling factor - convert from preview coordinates to original size coordinates
                const positionScaleX =
                    originalWidth / frameDimensions.clientWidth;
                const positionScaleY =
                    originalHeight / frameDimensions.clientHeight;

                // Calculate properly scaled position values
                const positionPixels = {
                    left: (state.positionRatio.left || 0) * frameDimensions.clientWidth * positionScaleX,
                    top: (state.positionRatio.top || 0) * frameDimensions.clientHeight * positionScaleY,
                };

                if (!window[`scaleX_${index}`])
                    window[`scaleX_${index}`] = state.scaleX;
                if (!window[`scaleY_${index}`])
                    window[`scaleY_${index}`] = state.scaleY;

                const scaleX = (state.scaleXRatio * frameDimensions.clientWidth) / (imageDimensions.naturalWidth || 1);
                const scaleY = (state.scaleYRatio * frameDimensions.clientHeight) / (imageDimensions.naturalHeight || 1);

                const sizePixels = {
                    width: imageDimensions.naturalWidth
                        ? ((imageDimensions.naturalWidth * scaleX) / frameDimensions.clientWidth) * originalWidth
                        : originalWidth,
                    height: imageDimensions.naturalHeight
                        ? ((imageDimensions.naturalHeight * scaleY) / frameDimensions.clientHeight) * originalHeight
                        : originalHeight,
                };

                const opacityVal = parseInt(
                    document.getElementById(
                        "editing-tool-adjust-opacity-slider"
                    ).value
                );

                const customColorPicker = document.getElementById('custom-color-picker');
                let colorValue = null;

                // Only include color if the swatch has been selected
                if (customColorPicker) {
                    console.log("Selected color:", customColorPicker.value);
                    colorValue = customColorPicker.value;
                }

                // Create payload for this smart object
                const payload = {
                    uuid: uuid,
                    asset: {
                        url: state.imageUrl,
                        size: sizePixels,
                        position: positionPixels,
                    },
                    adjustment_layers: {
                        opacity: opacityVal,
                    },
                };

                // Add color to payload only if a color has been selected
                if (colorValue) {
                    console.log("Applying color overlay:", colorValue);
                    payload.color = colorValue;
                } else {
                    console.log("No color overlay applied");
                }

                return payload;
            }
        );

    // Call the API to render the mockup
    const requestData = {
        mockup_uuid: window.selectedTemplate.mockupUuid,
        smart_objects: smartObjects,
    };

    // Make the API request
    fetch(`${backendURL}/render-mockup`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
    })
        .then(response => {
            if (response.status === 429) {
            showTooManyRequestsPopup();
            throw new Error("Too many requests");
            }
            return response.json();
        })
        .then((data) => {
            console.log("API Response:", data);

            if (data.status === "success") {
                const renderedUrl = data.data.data.export_path;

                if (renderedUrl) {
                    // Create a new image object
                    const renderedImg = new Image();
                    renderedImg.crossOrigin = "anonymous";

                    renderedImg.onload = function () {
                        // Clear the loading message
                        previewSection.innerHTML = "";
                        ensureDownloadUI();

                        // Use the preview-image-clip container for clipping and scaling
                        let previewClip = document.getElementById("preview-image-clip");
                        if (!previewClip) {
                            previewClip = document.createElement("div");
                            previewClip.className = "preview-image-clip";
                            previewClip.id = "preview-image-clip";
                            previewSection.appendChild(previewClip);
                        } else {
                            previewClip.innerHTML = ""; // Clear previous content
                            previewSection.appendChild(previewClip);
                        }

                        // Get the current slider value
                        const slider = document.getElementById("preview-slider");
                        const scale = slider ? slider.value / 100 : 1;
                        const baseWidth = renderedImg.naturalWidth;
                        const baseHeight = renderedImg.naturalHeight;
                        

                        // Add the properly sized image to the preview-image-clip
                        const imgElement = document.createElement("img");
                        imgElement.src = renderedUrl;
                        imgElement.alt = "Rendered Mockup";
                        imgElement.className = "rendered-mockup";
                        imgElement.style.width = (baseWidth * scale) + "px";
                        imgElement.style.height = (baseHeight * scale) + "px";
                        imgElement.style.maxWidth = "100%";
                        imgElement.style.maxHeight = "100%";
                        imgElement.style.objectFit = "contain";
                        imgElement.style.position = "absolute";
                        imgElement.style.left = "50%";
                        imgElement.style.top = "50%";
                        imgElement.style.transform = "translate(-50%, -50%)";

                        previewClip.appendChild(imgElement);

                        // Reattach slider event listener for preview scaling
                        slider.addEventListener("input", function () {
                            let img = document.querySelector(".rendered-mockup");
                            if (img && (img.naturalWidth || img.width)) {
                                const scale = slider.value / 100;
                                const baseWidth = renderedImg.naturalWidth;
                                const baseHeight = renderedImg.naturalHeight;
                                img.style.width = (baseWidth * scale) + "px";
                                img.style.height = (baseHeight * scale) + "px";
                            }
                        });
                    };

                    renderedImg.onerror = function () {
                        previewSection.innerHTML = `
                        <div class="error-message">
                            Failed to load rendered image.
                            <button class="retry-button">Retry</button>
                        </div>
                    `;
                        ensureDownloadUI();
                        document
                            .querySelector(".retry-button")
                            .addEventListener("click", function () {
                                applyImageToMockup();
                            });
                    };

                    // Start loading the image
                    renderedImg.src = renderedUrl;
                } else {
                    previewSection.innerHTML = `<div class="error-message">
                        Failed to load rendered image.
                    <button class="retry-button">Retry</button>
                </div>`;
                    ensureDownloadUI();

                    document
                        .querySelector(".retry-button")
                        .addEventListener("click", function () {
                            applyImageToMockup();
                        });
                }
            } else {
                // Show error message
                previewSection.innerHTML = `<div class="error-message">
                    Failed to load rendered image.
                        <button class="retry-button">Retry</button>
                    </div>`;
                ensureDownloadUI();

                document
                    .querySelector(".retry-button")
                    .addEventListener("click", function () {
                        applyImageToMockup();
                    });
            }
        })
        .catch((error) => {
            console.error("Error rendering mockup:", error);
                previewSection.innerHTML = `<div class="error-message">
                    Failed to load rendered image.
                <button class="retry-button">Retry</button>
            </div>`;
            ensureDownloadUI();
            document
                .querySelector(".retry-button")
                .addEventListener("click", function () {
                    applyImageToMockup();
                });
        });

    // Reattach slider event listener for preview scaling
    const slider = document.getElementById("preview-slider");
    const sliderValue = document.getElementById("slider-value");

    slider.addEventListener("input", function () {
        sliderValue.textContent = slider.value + "%";
        // Try to find the rendered image first, fallback to preview image
        let img = document.querySelector(".rendered-mockup") ||
                document.getElementById("mockup-result-preview-image");
        if (img && (img.naturalWidth || img.width)) {
            const scale = slider.value / 100;
            img.style.display = "block";
            // Use naturalWidth/naturalHeight if available, else current width/height
            const baseWidth = img.naturalWidth || img.width;
            const baseHeight = img.naturalHeight || img.height;
            img.style.width = (baseWidth * scale) + "px";
            img.style.height = (baseHeight * scale) + "px";
        }
    });

    // Optionally, trigger once on load
    slider.dispatchEvent(new Event("input"));

    ensureDownloadUI();
}

// Updated makeResizable function to maintain separate scaling
function makeResizable(imgElement) {
    const frame = document.getElementById("smart-object-frame");
    // Add directional handles
    const handles = ["nw", "n", "ne", "e", "se", "s", "sw", "w"];

    // Remove any existing resize handles
    document
        .querySelectorAll(".resize-handle")
        .forEach((handle) => handle.remove());

    // Store separate scale values for X and Y
    if (!window.imageScaleX) window.imageScaleX = imageScale;
    if (!window.imageScaleY) window.imageScaleY = imageScale;

    // Create resize handles at each position
    handles.forEach((position) => {
        const handle = document.createElement("div");
        handle.className = `resize-handle resize-handle-${position}`;
        frame.appendChild(handle);

        // Add specific cursor styles
        switch (position) {
            case "n":
            case "s":
                handle.style.cursor = "ns-resize";
                break;
            case "e":
            case "w":
                handle.style.cursor = "ew-resize";
                break;
            case "nw":
            case "se":
                handle.style.cursor = "nwse-resize";
                break;
            case "ne":
            case "sw":
                handle.style.cursor = "nesw-resize";
                break;
        }

        // Add event listeners for resizing
        handle.addEventListener("mousedown", function (e) {
            startResize(e, position);
        });

        handle.addEventListener("touchstart", function (e) {
            const touch = e.touches[0];
            const mouseEvent = new MouseEvent("mousedown", {
                clientX: touch.clientX,
                clientY: touch.clientY,
            });
            startResize(mouseEvent, position);
        });
    });

    function startResize(e, handlePosition) {
        e.preventDefault();
        e.stopPropagation();

        const startX = e.clientX;
        const startY = e.clientY;

        // Get current scales
        const startScaleX = window.imageScaleX || imageScale;
        const startScaleY = window.imageScaleY || imageScale;

        // Store original dimensions and position
        const startWidth = imgElement.naturalWidth * startScaleX;
        const startHeight = imgElement.naturalHeight * startScaleY;
        const startTop = imagePosition.top;
        const startLeft = imagePosition.left;

        // Store the handle position
        const resizingHandle = handlePosition;

        function resizeMove(moveEvent) {
            moveEvent.preventDefault();

            // Calculate how much the mouse has moved
            const dx = moveEvent.clientX - startX;
            const dy = moveEvent.clientY - startY;

            // Variables to store new values
            let newTop = startTop;
            let newLeft = startLeft;
            let newScaleX = startScaleX;
            let newScaleY = startScaleY;

            // Handle different resize directions
            switch (resizingHandle) {
                case "n": // North (top center) - stretch vertically only
                    // Calculate new height and adjust top position
                    const newHeightN = startHeight - dy;
                    if (newHeightN > 10) {
                        newScaleY =
                            newHeightN / imgElement.naturalHeight;
                        newTop = startTop + dy;
                    }
                    break;

                case "s": // South (bottom center) - stretch vertically only
                    // Calculate new height
                    const newHeightS = startHeight + dy;
                    if (newHeightS > 10) {
                        newScaleY =
                            newHeightS / imgElement.naturalHeight;
                    }
                    break;

                case "e": // East (right center) - stretch horizontally only
                    // Calculate new width
                    const newWidthE = startWidth + dx;
                    if (newWidthE > 10) {
                        newScaleX =
                            newWidthE / imgElement.naturalWidth;
                    }
                    break;

                case "w": // West (left center) - stretch horizontally only
                    // Calculate new width and adjust left position
                    const newWidthW = startWidth - dx;
                    if (newWidthW > 10) {
                        newScaleX =
                            newWidthW / imgElement.naturalWidth;
                        newLeft = startLeft + dx;
                    }
                    break;

                case "se": // Southeast (bottom right) - maintain aspect ratio
                    // Use the larger scale change to maintain aspect ratio
                    const seNewScale = Math.max(
                        (startWidth + dx) / imgElement.naturalWidth,
                        (startHeight + dy) /
                            imgElement.naturalHeight
                    );
                    newScaleX = newScaleY = seNewScale;
                    break;

                case "sw": // Southwest (bottom left) - maintain aspect ratio
                    // Use the larger scale change to maintain aspect ratio
                    const swNewScale = Math.max(
                        (startWidth - dx) / imgElement.naturalWidth,
                        (startHeight + dy) /
                            imgElement.naturalHeight
                    );
                    newScaleX = newScaleY = swNewScale;
                    newLeft = startLeft + dx;
                    break;

                case "ne": // Northeast (top right) - maintain aspect ratio
                    // Use the larger scale change to maintain aspect ratio
                    const neNewScale = Math.max(
                        (startWidth + dx) / imgElement.naturalWidth,
                        (startHeight - dy) /
                            imgElement.naturalHeight
                    );
                    newScaleX = newScaleY = neNewScale;
                    newTop = startTop + dy;
                    break;

                case "nw": // Northwest (top left) - maintain aspect ratio
                    // Use the larger scale change to maintain aspect ratio
                    const nwNewScale = Math.max(
                        (startWidth - dx) / imgElement.naturalWidth,
                        (startHeight - dy) /
                            imgElement.naturalHeight
                    );
                    newScaleX = newScaleY = nwNewScale;
                    newTop = startTop + dy;
                    newLeft = startLeft + dx;
                    break;
            }

            // Ensure minimum and maximum scale
            newScaleX = Math.max(0.1, Math.min(5, newScaleX));
            newScaleY = Math.max(0.1, Math.min(5, newScaleY));

            // Store the scales for later use
            window.imageScaleX = newScaleX;
            window.imageScaleY = newScaleY;

            // Calculate average scale for API calls where uniform scale is needed
            imageScale = (newScaleX + newScaleY) / 2;

            // Apply separate X and Y scales to the image
            imgElement.style.transform = `translate(${newLeft}px, ${newTop}px) scaleX(${newScaleX}) scaleY(${newScaleY})`;

            // Update position
            imagePosition.top = newTop;
            imagePosition.left = newLeft;

            // Update resize handles positions with correct dimensions
            updateHandlePositions(imgElement);
        }

        function resizeEnd() {
            document.removeEventListener("mousemove", resizeMove);
            document.removeEventListener("mouseup", resizeEnd);
            document.removeEventListener(
                "touchmove",
                touchResizeMove
            );
            document.removeEventListener("touchend", resizeEnd);

            // Check center alignment after resize is complete
            //checkCenterAlignment(imgElement);

            // If template is selected, rerender the mockup
            if (window.selectedTemplate && window.selectedUpload) {
                if (window.renderTimer)
                    clearTimeout(window.renderTimer);
                window.renderTimer = setTimeout(() => {
                    applyImageToMockup();
                }, 300);
            }
        }

        function touchResizeMove(e) {
            const touch = e.touches[0];
            const mouseEvent = new MouseEvent("mousemove", {
                clientX: touch.clientX,
                clientY: touch.clientY,
            });
            resizeMove(mouseEvent);
        }

        document.addEventListener("mousemove", resizeMove);
        document.addEventListener("mouseup", resizeEnd);
        document.addEventListener("touchmove", touchResizeMove);
        document.addEventListener("touchend", resizeEnd);
    }

    // Initial handle position update
    updateHandlePositions(imgElement);
}

// Updated updateHandlePositions function to use separate X and Y scales
function updateHandlePositions(imgElement) {
    if (!imgElement) return;

    const frame = document.getElementById("smart-object-frame");
    if (!frame) return;

    // Use separate scales if available, otherwise use the uniform scale
    const scaleX = window.imageScaleX || imageScale;
    const scaleY = window.imageScaleY || imageScale;

    // Calculate dimensions using the separate scales
    const transformedWidth = imgElement.naturalWidth * scaleX;
    const transformedHeight = imgElement.naturalHeight * scaleY;

    const top = imagePosition.top;
    const left = imagePosition.left;

    // Center points for N,S,E,W handles
    const centerX = left + transformedWidth / 2;
    const centerY = top + transformedHeight / 2;

    // Handle sizes (match your CSS)
    const cornerSize = 10;
    const n_s_width = 30, n_s_height = 10;
    const e_w_width = 10, e_w_height = 30;

    // Update corner handles
    const nwHandle = document.querySelector(".resize-handle-nw");
    const neHandle = document.querySelector(".resize-handle-ne");
    const swHandle = document.querySelector(".resize-handle-sw");
    const seHandle = document.querySelector(".resize-handle-se");

    // Update side handles
    const nHandle = document.querySelector(".resize-handle-n");
    const sHandle = document.querySelector(".resize-handle-s");
    const eHandle = document.querySelector(".resize-handle-e");
    const wHandle = document.querySelector(".resize-handle-w");

    // Position the handles based on the stretched dimensions
    if (nwHandle) {
        nwHandle.style.top = `${top - cornerSize / 2}px`;
        nwHandle.style.left = `${left - cornerSize / 2}px`;
    }

    if (neHandle) {
        neHandle.style.top = `${top - cornerSize / 2}px`;
        neHandle.style.left = `${left + transformedWidth - cornerSize / 2}px`;
    }

    if (swHandle) {
        swHandle.style.top = `${top + transformedHeight - cornerSize / 2}px`;
        swHandle.style.left = `${left - cornerSize / 2}px`;
    }

    if (seHandle) {
        seHandle.style.top = `${top + transformedHeight - cornerSize / 2}px`;
        seHandle.style.left = `${left + transformedWidth - cornerSize / 2}px`;
    }

    // Update middle edge handles (centered with new sizes)
    if (nHandle) {
        nHandle.style.top = `${top - n_s_height / 2}px`;
        nHandle.style.left = `${centerX - n_s_width / 2}px`;
    }

    if (sHandle) {
        sHandle.style.top = `${top + transformedHeight - n_s_height / 2}px`;
        sHandle.style.left = `${centerX - n_s_width / 2}px`;
    }

    if (eHandle) {
        eHandle.style.top = `${centerY - e_w_height / 2}px`;
        eHandle.style.left = `${left + transformedWidth - e_w_width / 2}px`;
    }

    if (wHandle) {
        wHandle.style.top = `${centerY - e_w_height / 2}px`;
        wHandle.style.left = `${left - e_w_width / 2}px`;
    }
}

// ############# SMART OBJECT MANAGEMENT ###############
// Update the updateSmartObjectFrame function to add navigation
function updateSmartObjectFrame(smartObjectIndex) {
    if (
        !currentSmartObjectSizes ||
        currentSmartObjectSizes.length === 0
    ) {
        console.warn("No smart object sizes available");
        return;
    }

    currentSmartObjectIndex = smartObjectIndex;
    const smartObjectSize =
        currentSmartObjectSizes[smartObjectIndex];

    if (
        !smartObjectSize ||
        !smartObjectSize.width ||
        !smartObjectSize.height
    ) {
        console.warn(
            "Invalid smart object size data:",
            smartObjectSize
        );
        return;
    }

    // Get the frame element
    const frame = document.getElementById("smart-object-frame");

    // Calculate a scale that fits the frame within the container
    const container = document.querySelector(
        ".editing-tool-upload-section"
    );
    const maxWidth = container.clientWidth - 40; // Account for padding

    // Original dimensions from API
    const originalWidth = parseInt(smartObjectSize.width);
    const originalHeight = parseInt(smartObjectSize.height);

    // Calculate aspect ratio
    const aspectRatio = originalWidth / originalHeight;

    // Extreme aspect ratio logic
    const EXTREME_RATIO = 4.0; // You can adjust this threshold
    let scaledWidth = originalWidth;
    let scaledHeight = originalHeight;

    if (aspectRatio > EXTREME_RATIO) {
        // Too wide: limit width, scale height accordingly
        scaledWidth = Math.min(maxWidth, originalWidth) * 1.5;
        scaledHeight = scaledWidth / aspectRatio * 1.5;
    } else if (aspectRatio < 1 / EXTREME_RATIO) {
        // Too tall: limit height, scale width accordingly
        scaledHeight = Math.min(maxWidth, originalHeight) * 1.5;
        scaledWidth = scaledHeight * aspectRatio * 1.5;
    } else if (originalWidth > maxWidth) {
        // Normal ratio, but too large: scale down
        scaledWidth = maxWidth;
        scaledHeight = maxWidth / aspectRatio;
    }

    // Update the frame dimensions
    frame.style.width = `${scaledWidth}px`;
    frame.style.height = `${scaledHeight}px`;

    // Update navigation buttons if there are multiple smart objects
    updateSmartObjectNavigation();
    console.log(
        "Adjusting left column height for new smart object frame"
    );
}

// Function to reset the smart object frame 
function resetSmartObjectFrame() {
    const imageContainer = document.getElementById(
        "draggable-image-container"
    );

    const resizeHandles =
        document.querySelectorAll(".resize-handle");
    resizeHandles.forEach((handle) => {
        handle.style.display = "none";
    });

    const frame = document.getElementById("smart-object-frame");
    if (frame) {
        frame.style.width = "15vw";
        frame.style.height = "15vw";
    }

    // Reattach event listener to the new upload button
    const autoUploadButton =
        document.getElementById("auto-upload-button");
    const fileInput = document.getElementById("image-file-input");

    if (autoUploadButton && fileInput) {
        autoUploadButton.addEventListener("click", function () {
            fileInput.click();
        });
    }

    // Reset position and scale
    imagePosition = { top: 0, left: 0 };
    imageScale = 1;
    window.imageScaleX = 1;
    window.imageScaleY = 1;

    // Clear the selected upload for this smart object
    if (window.selectedUpload) {
        window.selectedUpload[currentSmartObjectIndex] = null;
    }

    window[`scaleX_${currentSmartObjectIndex}`] = 1;
    window[`scaleY_${currentSmartObjectIndex}`] = 1;

    // Update state
    if (
        window.smartObjectsState &&
        window.smartObjectsState[currentSmartObjectIndex]
    ) {
        window.smartObjectsState[currentSmartObjectIndex] = {
            imageUrl: null,
            position: { top: 0, left: 0 },
            scaleX: 1,
            scaleY: 1,
            hasImage: false,
        };
    }
}

// Smart object navigation
function updateSmartObjectNavigation() {
    // Check if we have multiple smart objects to navigate between
    if (
        !currentSmartObjectSizes ||
        currentSmartObjectSizes.length <= 1
    ) {
        // If there's only 0 or 1 smart object, no need for navigation
        const existingNav = document.querySelector(
            ".smart-object-navigation"
        );
        if (existingNav) existingNav.remove();
        return;
    }

    // Look for existing navigation, create if not found
    let navContainer = document.querySelector(
        ".smart-object-navigation"
    );

    if (!navContainer) {
        // Create the navigation container
        navContainer = document.createElement("div");
        navContainer.className = "smart-object-navigation";

        // Add counter display
        const counter = document.createElement("div");
        counter.className = "smart-object-counter";
        navContainer.appendChild(counter);

        // Create left arrow
        const leftArrow = document.createElement("button");
        leftArrow.className = "smart-object-nav-btn nav-left";
        leftArrow.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"> <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"/> </svg>';
        leftArrow.title = "Previous smart object";
        leftArrow.addEventListener(
            "click",
            navigateToPrevSmartObject
        );

        // Create right arrow
        const rightArrow = document.createElement("button");
        rightArrow.className = "smart-object-nav-btn nav-right";
        rightArrow.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"> <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"/></svg>';
        rightArrow.title = "Next smart object";
        rightArrow.addEventListener(
            "click",
            navigateToNextSmartObject
        );

        // Add arrows to container
        navContainer.appendChild(leftArrow);
        navContainer.appendChild(rightArrow);

        // Properly insert the navigation in the upload section
        const uploadSection = document.querySelector(
            ".editing-tool-upload-section"
        );
        if (uploadSection) {
            // Insert at the beginning of the upload section
            uploadSection.appendChild(navContainer);
        } else {
            alert("ipak nes treba da stoji tu")
        }
    }

    // Update the counter display
    const counter = navContainer.querySelector(
        ".smart-object-counter"
    );
    counter.textContent = `Smart Object ${
        currentSmartObjectIndex + 1
    } of ${currentSmartObjectSizes.length}`;

    // Store state of each smart object if not already initialized
    if (!window.smartObjectsState) {
        window.smartObjectsState = new Array(
            currentSmartObjectSizes.length
        )
            .fill(null)
            .map(() => ({
                imageUrl: null,
                position: { top: 0, left: 0 },
                scaleX: 1,
                scaleY: 1,
                hasImage: false,
            }));
    }
}

// Function to navigate to previous smart object
function navigateToPrevSmartObject() {
    if (
        !currentSmartObjectSizes ||
        currentSmartObjectSizes.length <= 1
    )
        return;

    // Reset frame size to default
    const frame = document.getElementById("smart-object-frame");
    if (frame) {
        frame.style.width = "15vw";
        frame.style.height = "15vw";
    }
                
    // Save current smart object state
    //saveCurrentSmartObjectState();

    // Navigate to previous smart object
    const newIndex =
        (currentSmartObjectIndex -
            1 +
            currentSmartObjectSizes.length) %
        currentSmartObjectSizes.length;

    // Update frame and load state
    updateSmartObjectFrame(newIndex);
    loadSmartObjectState(newIndex);

    // Update counter
    const counter = document.querySelector(".smart-object-counter");
    if (counter)
        counter.textContent = `Smart Object ${newIndex + 1} of ${
            currentSmartObjectSizes.length
        }`;
}

// Function to navigate to next smart object
function navigateToNextSmartObject() {
    if (
        !currentSmartObjectSizes ||
        currentSmartObjectSizes.length <= 1
    )
        return;

    // Reset frame size to default
    const frame = document.getElementById("smart-object-frame");
    if (frame) {
        frame.style.width = "15vw";
        frame.style.height = "15vw";
    }

    // Save current smart object state
    //saveCurrentSmartObjectState();

    // Navigate to next smart object
    const newIndex =
        (currentSmartObjectIndex + 1) %
        currentSmartObjectSizes.length;

    // Update frame and load state
    updateSmartObjectFrame(newIndex);
    loadSmartObjectState(newIndex);

    // Update counter
    const counter = document.querySelector(".smart-object-counter");
    if (counter)
        counter.textContent = `Smart Object ${newIndex + 1} of ${
            currentSmartObjectSizes.length
        }`;
}

// Smart object state management
function saveCurrentSmartObjectState() {
    if (!window.smartObjectsState) {
        window.smartObjectsState = new Array(
            currentSmartObjectSizes.length
        )
            .fill(null)
            .map(() => ({
                imageUrl: null,
                position: { top: 0, left: 0 },
                scaleX: 1,
                scaleY: 1,
                hasImage: false,
                imageDimensions: null,
                frameDimensions: null,
            }));
    }

    const smartObjectSize = currentSmartObjectSizes[currentSmartObjectIndex];
const originalWidth = parseInt(smartObjectSize.width, 10);
    const originalHeight = parseInt(smartObjectSize.height, 10);
    const frame = document.getElementById("smart-object-frame");
    const img = document.querySelector(
        "#draggable-image-container img"
    );
    // Save scale and position as ratios
    window.smartObjectsState[currentSmartObjectIndex] = {
        imageUrl: img ? img.src : null,
        positionRatio: {
            left: imagePosition.left / frame.clientWidth,
            top: imagePosition.top / frame.clientHeight,
        },
        scaleXRatio: (window.imageScaleX || imageScale) * (img ? img.naturalWidth : 1) / frame.clientWidth,
        scaleYRatio: (window.imageScaleY || imageScale) * (img ? img.naturalHeight : 1) / frame.clientHeight,
        hasImage: img !== null,
        imageDimensions: img
            ? {
                naturalWidth: img.naturalWidth,
                naturalHeight: img.naturalHeight,
            }
            : null,
        frameDimensions: frame
            ? {
                clientWidth: frame.clientWidth,
                clientHeight: frame.clientHeight,
            }
            : null,
    };
}

// Load smart object state
function loadSmartObjectState(index) {
    if (
        !window.smartObjectsState ||
        !window.smartObjectsState[index]
    )
        return;

    const frame = document.getElementById("smart-object-frame");
    const state = window.smartObjectsState[index];

    // Get the image container
    const imageContainer = document.getElementById(
        "draggable-image-container"
    );

    if (state.hasImage && state.imageUrl) {
        imagePosition = {
            left: state.positionRatio.left * frame.clientWidth,
            top: state.positionRatio.top * frame.clientHeight,
        };
        window.imageScaleX = (state.scaleXRatio * frame.clientWidth) / (state.imageDimensions ? state.imageDimensions.naturalWidth : 1);
        window.imageScaleY = (state.scaleYRatio * frame.clientHeight) / (state.imageDimensions ? state.imageDimensions.naturalHeight : 1);
        imageScale = (window.imageScaleX + window.imageScaleY) / 2;

        // Clear container
        imageContainer.innerHTML = "";

        // Create and add image
        const img = document.createElement("img");
        img.crossOrigin = "anonymous";
        img.src = state.imageUrl;
        img.style.zIndex = "-1";

        img.onload = function () {
            // Store dimensions in the state if they aren't already there
            if (!state.imageDimensions) {
                state.imageDimensions = {
                    naturalWidth: img.naturalWidth,
                    naturalHeight: img.naturalHeight,
                };
            }

            const frame =
                document.getElementById("smart-object-frame");
            if (frame && !state.frameDimensions) {
                state.frameDimensions = {
                    clientWidth: frame.clientWidth,
                    clientHeight: frame.clientHeight,
                };
            }

            // Add the image to container
            imageContainer.appendChild(img);

            // Apply positioning and scaling
            updateImageTransform(img);

            // Make the image draggable and resizable
            makeDraggable(img);
            makeResizable(img);
        };

        img.onerror = function () {
            console.error(
                "Failed to load image from state:",
                state.imageUrl
            );
            resetSmartObjectFrame();
        };
    } else {
        // No image in this state, reset to upload button
        resetSmartObjectFrame();
        showLargeUploadUI(true);

        // Hide/remove the image remove button if present
        const removeBtn = document.querySelector('.image-remove-button');
        if (removeBtn) removeBtn.style.display = "none";
    }

    console.log("Loaded smart object state:", state);
}
// ############# SMART OBJECT MANAGEMENT ###############
